import { useQuery } from 'react-query';

import { getRolesList as queryFn } from 'api/endPoints/getRolesList';

export interface IGetRolesList {
    customerId: null;
    id: number;
    name: string;
    label: string;
    privilegeList: {
        customerId: null;
        id: number;
        objectName: string;
        permissions: { reportDate: null; customerId: null; id: number; name: string }[];
        reportDate: null;
    }[];
    reportDate: null;
}

export const useQueryGetRolesList = () => {
    return useQuery<IGetRolesList[], QueryError>('getRolesList', () => queryFn(), {
        placeholderData: [],
    });
};
